






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component
export default class PersonSearchIcon extends Vue {
	@Prop({default: 'white'}) public color: string;
}
